import {
  mapPerspectiveDtoToModel,
  PerspectiveDto,
  PerspectiveModel,
} from 'api/dto/new/Perspectives/Perspective.dto';
import { CreditDto, CreditModel, mapCreditDtoToModel } from 'api/dto/new/Perspectives/Credit.dto';

// TODO: return PerspectivesListDto type from comment below once DTO injections are removed
// export type PerspectivesListDto = components['schemas']['PerspectivesListResultDTO'];

export type PerspectiveListDto = {
  perspectives: PerspectiveDto[];
  credit: CreditDto;
};

export type PerspectivesListModel = Readonly<{
  perspectives: PerspectiveModel[];
  credit: CreditModel;
}>;

export const mapPerspectivesListDtoToModel = (dto: PerspectiveListDto): PerspectivesListModel => ({
  perspectives: dto.perspectives.map(mapPerspectiveDtoToModel),
  credit: mapCreditDtoToModel(dto.credit),
});
